import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import TranslateForm from './TranslateForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import * as actions from "./store/translateActions";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const TranslationEdit = props => {
    const { translate, activeCustomer, classes, loading, translations, permissions, editTranslationInit } = props;
    const translation = translate.loaded ? translate.loaded : {}
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await props.loadTranslation({ ActiveCustomerID: activeCustomer, TranslationID: parseURL(window.location.href).translationID })
            setData(false)
        }
        fetchData();
        return () => {
            editTranslationInit()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = data => {
        data['TranslationID'] = translation.TranslationID

        data['Translations'] = { en: data.English, de: data.German }
        delete data.English
        delete data.German

        let result = props.editTranslation({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    };


    let initialValues = { Key: translation && translation.Key ? translation.Key : "", English: translation.Translations ? JSON.parse(translation.Translations).en ? JSON.parse(translation.Translations).en : '' : '-', German: translation.Translations ? JSON.parse(translation.Translations).de ? JSON.parse(translation.Translations).de : '' : '-' };

    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_permission'] || "Edit translation",
        ButtonSubmit: hasPermission(permissions, "translation_save") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    // Render form
    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >
                <AppLogoLoading />
            </Dialog>
            {!data ?
                <TranslateForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></TranslateForm>
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>

    );
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translate: state.translate.translations,

        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadTranslation: filterParams => dispatch(actions.loadTranslation(filterParams)),
        editTranslation: data => dispatch(actions.editTranslations(data)),
        editTranslationInit: data => dispatch(actions.editTranslationsInit(data))

    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TranslationEdit));
